import { render, staticRenderFns } from "./SquareBox.vue?vue&type=template&id=18576c0e&scoped=true&"
import script from "./SquareBox.vue?vue&type=script&lang=js&"
export * from "./SquareBox.vue?vue&type=script&lang=js&"
import style0 from "./SquareBox.vue?vue&type=style&index=0&id=18576c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18576c0e",
  null
  
)

export default component.exports